import { Zap } from "lucide-react";

export default function LightningBanner({ onGetFunded }) {
  return (
    <div
      data-testid="lightning-banner"
      className="fixed top-0 left-0 right-0 z-[60] h-9 bg-gradient-to-r from-amber-400 via-orange-500 to-fuchsia-600 text-white text-xs md:text-sm font-semibold shadow-lg"
    >
      <div className="max-w-7xl mx-auto h-full px-4 md:px-10 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Zap className="w-4 h-4 flex-shrink-0 fill-white" />
          <span className="truncate">
            <span className="hidden sm:inline">
              <b>Lightning Funding</b> — need cash today? Same-day approval, funded in as fast as 4 hours.
            </span>
            <span className="sm:hidden">
              <b>Lightning Funding</b> — funded in as fast as 4 hours.
            </span>
          </span>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            data-testid="lightning-banner-cta"
            onClick={onGetFunded}
            className="hidden sm:inline-flex items-center gap-1 rounded-full bg-white text-slate-900 hover:bg-slate-50 px-3 py-1 text-[11px] font-bold uppercase tracking-widest transition-colors"
          >
            Get funded today →
          </button>
          <a
            href="#lightning-funding"
            data-testid="lightning-banner-link"
            className="sm:hidden text-[11px] font-bold uppercase tracking-widest underline underline-offset-4"
          >
            Details
          </a>
        </div>
      </div>
    </div>
  );
}
